import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { SVGIcon } from '../../../atoms/SVG';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonMinorActionSpecificProps = {
  text: string;
  icon: SVGIcon;
  disabledLink?: boolean;
  active?: boolean;
  type?: 'button' | 'submit' | 'reset';
  formAction?: string;
  focusOnMount?: boolean;
  reference?: ButtonRefType;
  href?: string;
  routing?: boolean;
  popoverTarget?: string;
  popoverTargetAction?: 'toggle' | 'show' | 'hide';
  tooltipPlacement?: TooltipPlacement;
};

export type ButtonMinorActionProps = SharedButtonProps & ButtonMinorActionSpecificProps;

export function ButtonMinorAction({
  text,
  icon,
  onClick,
  onKeyDown,
  onKeyUp,
  disabled,
  disabledLink,
  ariaDisabled,
  ariaExpanded,
  ariaControls,
  active,
  type = 'button',
  ariaLabel,
  formAction,
  focusOnMount,
  reference,
  href,
  routing,
  popoverTarget,
  popoverTargetAction,
  tooltipPlacement,
  ...rest
}: ButtonMinorActionProps) {
  const modifier = active
    ? [BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT, BtnModifier.ACTIVE]
    : [BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT];

  return (
    <Btn
      {...rest}
      modifier={modifier}
      text={text}
      svgSpriteId={icon}
      hiddenText
      onClick={onClick}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      disabled={disabled}
      disabledLink={disabledLink}
      ariaDisabled={ariaDisabled}
      ariaExpanded={ariaExpanded}
      ariaControls={ariaControls}
      type={type}
      titleText={text}
      ariaLabel={ariaLabel}
      formAction={formAction}
      focusOnMount={focusOnMount}
      reference={reference}
      href={href}
      routing={routing}
      popoverTarget={popoverTarget}
      popoverTargetAction={popoverTargetAction}
      tooltipPlacement={tooltipPlacement}
    />
  );
}
